module.exports = __webpack_public_path__ + "img/p1-p1-logo.5545dc30.png";